import React, { useCallback, useEffect, useRef, useState } from 'react';
import { navPropTypes } from './NavPropTypes';
import { BREAKPOINTS } from '@Theme/natucare/constants/breakpoints';
import { DEVICE_TYPES } from '@Theme/natucare/constants/deviceTypes';
import MegaMenu from './components/MegaMenu/MegaMenu';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { useDeviceDetect } from '@App/common/hooks/useDeviceDetect';
import * as styles from './Nav.module.scss';
const Nav = ({
  items,
  isMobileOpen,
  isSearching
}) => {
  if (!items) {
    return null;
  }
  const navRef = useRef(null);
  const {
    deviceType
  } = useDeviceDetect(BREAKPOINTS);
  const isDesktop = deviceType !== DEVICE_TYPES[BREAKPOINTS.XS] && deviceType !== DEVICE_TYPES[BREAKPOINTS.SM] && deviceType !== DEVICE_TYPES[BREAKPOINTS.MD];
  const {
    0: navItemOpenedIndex,
    1: setNavItemOpenedIndex
  } = useState(-1);
  const handleNavItemClick = useCallback((e, index) => {
    if (isDesktop) {
      return;
    }
    e.stopPropagation();
    setNavItemOpenedIndex(prevState => prevState === index ? -1 : index);
  }, [deviceType]);
  useEffect(() => {
    if (navRef.current && navItemOpenedIndex !== -1) {
      navRef.current.scrollTop = 0;
    }
  }, [navItemOpenedIndex]);
  useEffect(() => {
    if (!isMobileOpen) {
      setNavItemOpenedIndex(-1);
    }
  }, [isMobileOpen]);
  const rootClassnames = `
    ${styles.root} 
    ${isMobileOpen ? styles.rootMobileOpened : ''}
    ${isSearching ? styles.rootSearching : ''}
    ${navItemOpenedIndex !== -1 ? styles.rootOverflowHidden : ''}
  `;
  const generateItemVariantClassname = classname => {
    return `rootListItem${classname.charAt(0).toUpperCase()}${classname.slice(1)}`;
  };
  return /*#__PURE__*/React.createElement("nav", {
    className: rootClassnames,
    ref: navRef
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.rootList
  }, items.map((item, index) => {
    var _item$breakpoint, _item$breakpoint2;
    const Component = item.href ? 'a' : 'span';
    return /*#__PURE__*/React.createElement("li", {
      onClick: e => handleNavItemClick(e, index),
      className: `
              ${styles.rootListItem}
              ${item !== null && item !== void 0 && item.variant ? styles[generateItemVariantClassname(item.variant)] : ''}
              ${item !== null && item !== void 0 && item.items ? styles.rootListItemMegaMenu : ''}
              ${typeof item.breakpoint !== 'undefined' && !((_item$breakpoint = item.breakpoint) !== null && _item$breakpoint !== void 0 && _item$breakpoint.desktop) ? styles.rootListItemHiddenDesktop : ''}
              ${typeof item.breakpoint !== 'undefined' && !((_item$breakpoint2 = item.breakpoint) !== null && _item$breakpoint2 !== void 0 && _item$breakpoint2.mobile) ? styles.rootListItemHiddenMobile : ''}`,
      key: index
    }, /*#__PURE__*/React.createElement(Component, {
      href: item.href,
      className: styles.rootListItemLabel
    }, item.label, item.badge && /*#__PURE__*/React.createElement("span", {
      className: styles.rootListItemLabelBadge
    }, item.badge), (item === null || item === void 0 ? void 0 : item.items) && /*#__PURE__*/React.createElement(Icon, {
      classname: styles.rootListItemLabelIcon,
      size: {
        width: 8,
        height: 14
      },
      name: "arrowNav"
    })), /*#__PURE__*/React.createElement(MegaMenu, {
      isNavItemOpen: navItemOpenedIndex === index,
      items: item.items,
      mobilePreviousLayerLabel: item.label,
      classname: styles.rootListItemMegaMenu
    }));
  })));
};
export default Nav;